
export class BallProps {
  constructor(
    public radius = 5,
  ) {}
}
